import React from "react";

const Helmet = (props) => {
  document.title = "Kuzey Kıbrıs Ercan Havalimanı ve Girne Araç Kiralama ";
  // document.description = "Kıbrıs Ercan Havalimanı ve Girne'de araba kiralama hizmeti vermekteyiz.Rezervasyon ve kiralama şartları için hemen tıkla."

  return <div className="w-100">{props.children}</div>;
};

export default Helmet;
